import React, { useState, useEffect } from 'react';
import { TextField, Button, Card, CardContent, Chip, Typography, Snackbar, IconButton, Tooltip, CircularProgress } from '@mui/material';
import referralImageIcon from './../../assets/referral-image.jpg';
import './referrals.css';
import { getReferrals, postReferrals, updateReferralStatus } from '../../Helper/adminModuleApi';
import { createLeads } from '../../Helper/companySignupApi';
import ErrorModal from '../../components/ErrorModal';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { VolunteerActivismRounded } from '@mui/icons-material';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';
import SnackBarMessage from '../../components/SnackBarMessage';
import SideBar from '../../SideBar';
import ForwardRoundedIcon from '@mui/icons-material/ForwardRounded';
import Divider from '@mui/material/Divider';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';

const initialFormData = {
    referral_first_name: '',
    referral_last_name: '',
    referral_email: '',
    referral_phone_number: '',
    referral_company: ''
};

function Referrals() {
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false); // Main loading state
    const [formData, setFormData] = useState(initialFormData);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [statusLoading, setStatusLoading] = useState(null); // State for tracking status update loader

    const fetchReferrals = async () => {
        setIsLoading(true);
        try {
            const response = await getReferrals();
            console.log("response", response?.data);
            const updatedRows = response?.data?.body.map((referral, index) => ({
                id: index,
                firstName: referral.referral_first_name,
                lastName: referral.referral_last_name,
                company: referral.referral_company,
                email: referral.referral_email,
                phone: referral.referral_phone_number,
                status: referral.referral_status,
                ...referral
            }));
            setRows(updatedRows);
        } catch (error) {
            console.error("An error occurred while fetching referrals data.", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const newReferrals = async () => {
        const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
        const referralData = {
            referred_company_uuid: userDetails.company_uuid,
            referred_user_id: userDetails.user_id,
            ...formData,
            referral_status: 'Pending',
            send_email: true
        };

        try {
            const response = await postReferrals(referralData);
            console.log("Upload Response:", response);
            if (response?.data?.status === 400) {
                setIsOpenModal(false);
                setTimeout(() => {
                    setErrorMessage("Failed to send the referral. Please try again.");
                    setIsOpenModal(true);
                }, 0);
            } else {

                setRows(prevRows => [
                    ...prevRows,
                    {
                        id: prevRows.length,
                        firstName: formData.referral_first_name,
                        lastName: formData.referral_last_name,
                        company: formData.referral_company,
                        email: formData.referral_email,
                        phone: formData.referral_phone_number,
                        status: 'Pending'
                    }
                ]);
                await newLeads(formData);
                setFormData(initialFormData);
                setSnackbarOpen(true);
                setSnackbarMessage('Referral sent successfully!');

            }
            await fetchReferrals();
        } catch (error) {
            console.error("Failed to upload referral:", error);
            setIsOpenModal(false);
            setTimeout(() => {
                setErrorMessage("Failed to send the referral. Please try again.");
                setIsOpenModal(true);
            }, 0);
        }
    };

    const newLeads = async (formData) => {
        console.log("formData", formData);
        const leadData = {
            first_name: formData.referral_first_name,
            last_name: formData.referral_last_name,
            email: formData.referral_email,
            phone: formData.referral_phone_number,
            website_url: "",
            company: formData.referral_company,
            description: "New referral"
        };

        try {
            const response = await createLeads(leadData);
            console.log("Lead creation response:", response);
            if (response?.data?.status === 200) {
                console.log("New lead created successfully");
            } else {
                console.error("Failed to create new lead");
            }
        } catch (error) {
            console.error("Failed to create new lead:", error);
        }
    };

    const getStatusClassName = (status) => {
        switch (status.toLowerCase()) {
            case 'pending':
                return 'fl-r status-chips bg-pending';
            case 'accepted':
                return 'fl-r status-chips bg-accepted';
            case 'rejected':
                return 'fl-r status-chips bg-rejected';
            default:
                return 'fl-r status-chips';
        }
    };

    const updateStatus = async (referral, status) => {
        setStatusLoading(referral.id); // Set loader for the specific referral
        const data = {
            referral_uuid: referral.referral_uuid,
            referral_status: status
        };
        try {
            await updateReferralStatus(data);
            await fetchReferrals();
        } catch (error) {
            console.error("Failed to update referral status:", error);
        } finally {
            setStatusLoading(null); // Reset loader once done
        }
    };

    const isFormComplete = Object.values(formData).every(value => value.trim() !== '');

    const fieldLabels = {
        referral_first_name: 'First Name',
        referral_last_name: 'Last Name',
        referral_email: 'Email',
        referral_phone_number: 'Phone Number',
        referral_company: 'Company'
    };

    const calculateTotalRewards = () => {
        let totalRewards = 0;
        rows.forEach(element => {
            if (element.status === 'Accepted') {
                totalRewards += 20;
            }
        });
        return totalRewards;
    };

    useEffect(() => {
        fetchReferrals();
    }, []);

    return (
        <div style={({ height: "100vh" }, { display: "flex" })}>
            <SideBar></SideBar>
            <div className='container-fluid overflow-x-none'>
                <div className='row'>
                    <main className='col-lg-12 mt-3'>
                        <div className="row justify-content-md-center">
                            <h2 className="text-center mt-3">Cartage Manager Referral Program</h2>
                            <span className="row justify-content-md-center">Refer a company to Cartage Manager and get rewarded</span>
                        </div>
                        <div className="row ref-div">
                            <div className="col-lg-6 my-2">
                                <img className="ref-img" src={referralImageIcon} alt="Referral Image" />
                                <div className="row text-center mt-2 ml-26r mr-2 mb-06r">
                                    <div className="col-lg-3">
                                        <VolunteerActivismRounded fontSize="large" style={{ color: '#FFD700' }} />
                                        <Typography variant="subtitle1" className='fs-08r'>Share your link with another business owner.</Typography>
                                    </div>
                                    <div className='col-lg-1 p-0 login-content'>
                                        <ForwardRoundedIcon></ForwardRoundedIcon>
                                    </div>
                                    <div className="col-lg-3">
                                        <HandshakeRoundedIcon fontSize="large" style={{ color: 'red' }} />
                                        <Typography variant="subtitle1" className='fs-08r'>They sign up and send atleast 50 documents</Typography>
                                    </div>
                                    <div className='col-lg-1 p-0 login-content'>
                                        <ForwardRoundedIcon></ForwardRoundedIcon>
                                    </div>
                                    <div className="col-lg-4">
                                        <CardGiftcardIcon fontSize="large" style={{ color: '#20B2AA' }} />
                                        <Typography variant="subtitle1" className='fs-08r'>Get a reward for each referred company.</Typography>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 p-2">
                                <Card className='card-height'>
                                    <CardContent>
                                        <div className="row p-2">
                                            <h5>Refer a Company</h5>
                                            {Object.keys(formData).map((key) => (
                                                <div key={key} className={`col-${key === 'referral_company' ? '12' : '6'}`}>
                                                    <TextField
                                                        fullWidth
                                                        label={fieldLabels[key]}
                                                        name={key}
                                                        value={formData[key]}
                                                        onChange={handleChange}
                                                        variant="outlined"
                                                        className="mb-2"
                                                    />
                                                </div>
                                            ))}
                                            <div className='col-lg-12'>
                                                <Button
                                                    onClick={newReferrals}
                                                    className={`col-12 ${isFormComplete ? 'theme-bg' : 'disabled-bg'} mt-2 btn-br-40p`}
                                                    variant="contained"
                                                    disabled={!isFormComplete}
                                                >
                                                    <span className="text-trans-none">Send Invite</span>
                                                </Button>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                                <ErrorModal
                                    isOpen={isOpenModal}
                                    message={errorMessage}
                                    onClose={() => setIsOpenModal(false)}
                                />
                                <SnackBarMessage
                                    isSnackbarOpen={snackbarOpen}
                                    snackBarMessage={snackbarMessage}
                                    setIsSnackbarOpen={setSnackbarOpen}
                                />
                            </div>
                            {/* <div className="col-lg-12">
                                <h5 className='text-center theme-color'>
                                    <img width="48" height="48" src="https://img.icons8.com/pulsar-gradient/48/receive-change.png" alt="receive-change" />
                                    {rows.length > 0 ? (
                                        <span> Congrats! You've earned ${calculateTotalRewards()} from {calculateTotalRewards() / 20} successful referrals!</span>
                                    ) : (
                                        <span>You haven't made any referrals yet. Start now to earn rewards!</span>
                                    )}
                                </h5>
                            </div> */}
                            <div className='col-12'>
                                <Divider className='bg-grey' />
                                <div className="row p-2">
                                    <h5>Your Referrals</h5>
                                    <div>
                                        {rows.length === 0 ? (
                                            <div className='div-center'>
                                                <p>No referrals to display</p>
                                            </div>
                                        ) : (
                                            <div className='row'>
                                                {rows.map((referral) => (
                                                    <div className='col-6 px-3' key={referral.id}>
                                                        <Card className='card-box-shadow mb-2'>
                                                            <CardContent className='p-2'>
                                                                <div>
                                                                    <span>{referral.firstName + " " + referral.lastName} - {referral.company}</span>
                                                                    <Chip className={getStatusClassName(referral.status)} label={referral.status} />
                                                                </div>
                                                                <div className='referrals-font-size'>
                                                                    <span>{referral.email}</span>
                                                                </div>
                                                                <div className='referrals-font-size'>
                                                                    <span>{referral.phone}</span>
                                                                    {referral.status === 'Pending' && (
                                                                        <>
                                                                            {statusLoading === referral.id ? (
                                                                                <CircularProgress size={24} className='fl-r' />
                                                                            ) : (
                                                                                <>
                                                                                    <Tooltip title="Accept">
                                                                                        <IconButton
                                                                                            className='fl-r p-0'
                                                                                            onClick={() => updateStatus(referral, 'Accepted')}
                                                                                        >
                                                                                            <CheckCircleOutlineIcon />
                                                                                        </IconButton>
                                                                                    </Tooltip>

                                                                                    <Tooltip title="Reject">
                                                                                        <IconButton
                                                                                            className='fl-r p-0 mr-2'
                                                                                            onClick={() => updateStatus(referral, 'Rejected')}
                                                                                        >
                                                                                            <CancelIcon />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </CardContent>
                                                        </Card>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
}

export default Referrals;
